// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"CompanyReourcesPage_pageWrapper__2zt5f"};